export default "__VITE_ASSET__D4L85I4s__"